module.exports = __webpack_public_path__ + "sideSprite-53e07fc2c442003da47487ae80ce05e4.png";